import React from 'react';
interface StickyAddToCartProps {
  isVisible: boolean;
}
export function StickyAddToCart({
  isVisible
}: StickyAddToCartProps) {
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up" data-id="element-525">
      <div className="max-w-4xl mx-auto px-4 py-4" data-id="element-526">
        <a href="https://lyrasleep.com/products/sleep-gummies" target="_blank" rel="noopener noreferrer" className="block" data-id="element-527">
          <button className="w-full bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 text-white font-bold px-6 py-4 rounded-full hover:from-purple-700 hover:via-pink-700 hover:to-purple-700 transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 text-center text-lg" data-id="element-528">
            CLAIM LIMITED TIME OFFER
          </button>
        </a>
      </div>
    </div>;
}